import { useParams } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

export interface OnBehalfBookingTarget {
  coachId: string;
  memberId: string;
  returnPath: string;
}

/**
 * The coach and member an on-behalf booking page books for, or null on the
 * member's own booking route. Ops names the coach in the URL
 * (`/coach/manage/coaches/:coachId/members/:memberId/...`); a coach books on
 * their own schedule (`/coach/schedule/members/:memberId/...`, MEN-5635), so
 * the coach is the session user and the page returns to their schedule.
 */
export const useOnBehalfBookingTarget = (): OnBehalfBookingTarget | null => {
  const { coachId, memberId } = useParams();
  const { user } = useCurrentUser();
  if (!memberId) return null;
  if (coachId) {
    return {
      coachId,
      memberId,
      returnPath: `/coach/manage/coaches/${coachId}/schedule`,
    };
  }
  return { coachId: user.id, memberId, returnPath: '/coach/schedule' };
};
